<template>
  <div class="container page-content">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <table-title :items="filteredItems" item-name="divisions">
            Divisions
          </table-title>
        </div>
      </div>
      <div class="level-right">
        <!-- <div class="level-item">
            <button class="button is-wide is-secondary">
              <span class="icon icon-filter"></span>
              <span>Filter</span>
            </button>
          </div> -->
        <div class="level-item">
          <search v-model="search" />
        </div>
      </div>
    </div>
    <confirm-dialog
      v-model="deleteDialog"
      @confirmed="deleteItem"
    ></confirm-dialog>

    <app-table :items="filteredItems" :headers="headers">
      <template v-slot:item.organization="{ item }">
        {{ getOrganization(item) }}
      </template>
      <template v-slot:item.workgroups="{ item }">
        {{ item.children | joinNames }}
      </template>
      <template v-slot:item.usersCount="{ item }">
        {{ sumUsers(item) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <button
          class="button is-text"
          @click.stop="
            deleteDialog = true;
            selectedID = item.groupID;
          "
        >
          <span class="icon icon-delete"></span>
        </button>
        <!-- <router-link
          :to="{
            name: 'divisions.view',
            params: { id: item.groupID }
          }"
          class="button is-secondary"
        >
          Edit -->
      </template>
    </app-table>
  </div>
</template>

<script>
import _ from 'lodash';
import AppTable from '@/components/AppTable.vue';
import Search from '@/components/Search.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import TableTitle from '@/components/TableTitle.vue';

export default {
  name: 'DivisionsLists',
  components: { AppTable, Search, ConfirmDialog, TableTitle },
  filters: {
    joinNames(value) {
      return _.map(value, 'name').join(', ');
    }
  },
  data() {
    return {
      create: false,
      divisions: [],

      search: '',
      selectedID: -1,
      deleteDialog: false
    };
  },
  computed: {
    filteredItems() {
      const tmp = this.$store.getters['groups/search'](this.search);
      //remove the Organization from the list
      return tmp.filter(division => {
        return (
          division != undefined && division.organizationLevel != 'Organization'
        );
      });
    },
    headers() {
      const headers = [
        {
          text: 'Division name',
          value: 'name',
          sortable: true,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return -1;
            }
            if (a.__name > b.__name) {
              return 1;
            }
            return 0;
          }
        },
        {
          text: 'Workgroups Within',
          value: 'workgroups'
        },
        {
          text: 'Number of users',
          value: 'usersCount',
          align: 'center',
          width: 300,
          sortable: true,
          customSort: (a, b) => {
            return this.sumUsers(a) - this.sumUsers(b);
          }
        },
        {
          text: '',
          value: 'actions',
          align: 'end',
          width: this.$singleActionColumnWidth
        }
      ];
      if (this.hasRole('ueg')) {
        headers.unshift({
          text: 'Organization',
          value: 'organization',
          width: 180
        });
      }
      return headers;
    }
  },
  mounted() {
    this.axiosRequest('get', 'Organizations')
      .then(response => {
        this.$store.commit('groups/set', _.flatMap(response.data, 'groups'));
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    deleteItem() {
      this.axiosRequest('delete', `Groups/${this.selectedID}`)
        .then(() => {
          this.$store.commit('groups/deleteById', this.selectedID);
          this.deleteDialog = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    },
    sumUsers(value) {
      return _.chain(value.children)
        .flatMap('users')
        .concat(value.users)
        .value().length;
    },
    getOrganization(division) {
      console.log(division);

      return _.chain(this.$store.getters['groups/organizations'])
        .find({
          organizationID: division.organizationID
        })
        .get('name')
        .value();
    }
  }
};
</script>

<style lang="scss"></style>
